module.exports = __webpack_public_path__ + "static/media/badeplass.9f108d72.jpg";